import { environment } from "@environment";
import { isValidUrl } from "@library/shared";
import type { ReactNode } from "react";
import { useIsPdf } from "../context";

interface Props {
  children: ReactNode;
  href?: string | null;
}

const assets: string = `${environment.base}/assets/images`;

const handleCloudinaryUrl = (url?: string) => {
  if (!url) return url;
  const updated = url
    .replace(
      "https://storydoc.mo.cloudinary.net/stg",
      "https://assets-staging.storydoc.com",
    )
    .replace(
      "https://storydoc.mo.cloudinary.net/prd",
      "https://assets.storydoc.com",
    );

  return updated.split("?")[0];
};

export const PdfLibVideoWrapper = ({ children, href }: Props) => {
  const isPdf = useIsPdf();
  if (!isPdf || !href) return <>{children}</>;

  let url = isValidUrl(href) ? href : undefined;
  if (url && !url.includes("https://")) {
    if (url.includes("http://")) url = url.replace("http", "https");
    else url = `https://${url}`;
  }
  url = handleCloudinaryUrl(url);

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="video-lib-pdf-thumbnail-contaienr"
    >
      <img
        width={24}
        height={24}
        className="video-pdf-lib-video-play-icon !tw-absolute !tw-bottom-2 !tw-left-2 !tw-right-auto !tw-top-auto !tw-z-10 !tw-size-6"
        src={`${assets}/pdf-video-play-icon.svg`}
        alt="Play icon"
      />
      {children}
    </a>
  );
};
